import moment from 'moment';
let filters ={
    datetimeFormat(value, type) {
        return value ? moment(value).format(type) : ""
    },
    upperCase(value) {
        return value ? value.toUpperCase() : value
    },
    lowerCase(value) {
        return value ? value.toLowerCase() : value
    },
    characterByte(value) {
        /*return value.toString().split('').map(s=>s.charCodeAt(0)).reduce((prev, c) => (prev + ((c === 10) ? 2 : ((c >> 7) ? 2 : 1))), 0)*/
        return value.toString().split('').map(s=>s.charCodeAt(0)).reduce((prev, c) => (prev + ((c === 10) ? 1 : ((c >> 7) ? 2 : 1))), 0)
    },
    replaceAll(str,searchStr,replaceStr) {
        return str.split(searchStr).join(replaceStr)
    },
    changeOptionsValueToText(value,options) {
        let filtered = options.filter(option => option.value === value)
        return filtered.length > 0 ? filtered[0].text : value
    },
    toBeShortString(value, limit) {
        return value.length > limit
            ? `${value.slice(0,limit)}...`
            : value
    }
}

export default {
    install(Vue) {
        Vue.prototype.$filters = filters
        Vue.filter('datetimeFormat',filters.datetimeFormat)
        Vue.filter('upperCase',filters.upperCase)
        Vue.filter('lowerCase',filters.lowerCase)
        Vue.filter('characterByte',filters.characterByte)
        Vue.filter('replaceAll',filters.replaceAll)
        Vue.filter('changeOptionsValueToText',filters.changeOptionsValueToText)
        Vue.filter('toBeShortString',filters.toBeShortString)
    }
};
